import React from "react";
import { Button, Modal, Toast, Badge, Icon } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
import DigitalCertificateProtocolText from "../modules/digitalCertificateProtocolText";
import api from "./api";
import Cookies from "js-cookie";

import bgPNG from "./image/bg.png";
import gerenPNG from "./image/geren.png";
import qiyePNG from "./image/qiye.png";

import "./index.less";

class ACGuide extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      type: false,
      DCPType: false,
      iconType: false,
      urlOps: {},
    };
  }

  componentDidMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
      this.setState(
        {
          urlOps: ops,
        },
        () => {
          if (ops.plateformType) {
            this.checkCertification(ops.plateformType);
          } else {
            if (ops.app_stoken) {
              localStorage.setItem("thirdContractId", ops.thirdContractId);
              localStorage.setItem("app_stoken", ops.app_stoken);
              Cookies.remove("session_key");
              localStorage.removeItem("sessionKey");
              this.checkCertification();
            } else if (ops.sessionKey) {
              localStorage.setItem("thirdContractId", ops.thirdContractId);
              localStorage.setItem("sessionKey", ops.sessionKey);
              Cookies.remove("session_key");
              localStorage.removeItem("app_stoken");
              this.checkCertification();
            } else {
              localStorage.removeItem("app_stoken");
              localStorage.removeItem("sessionKey");
              if (Cookies.get("session_key")) {
                // this.checkCertification();

                if (ops.certification === "1") {
                  href("/ACFaceCa");
                } else {
                  if (ops.tiertype != 4) {
                    this.setState({
                      type: false,
                    });
                  } else {
                    this.setState({
                      type: true,
                    });
                  }
                }
              } else {
                href("/ACLogin");
              }
            }
          }
        }
      );
    }
  }

  checkCertification = (plateformType) => {
    let _this = this;
    let url = "";
    if (localStorage.getItem("app_stoken")) {
      url =
        api.h5.checkCertification +
        "?app_stoken=" +
        localStorage.getItem("app_stoken");
    } else if (localStorage.getItem("sessionKey")) {
      url =
        api.wechat.checkCertification +
        "?sessionKey=" +
        localStorage.getItem("sessionKey");
    } else {
      url =
        api.h5.checkCertification +
        "?session_key=" +
        Cookies.get("session_key");
    }
    post({
      url: url,
      data: {},
    }).then(
      (res) => {
        console.log("校验是否实名", res);
        // Toast.info(res.msg,1);
        if (res.result === "success") {
          if (res.code === "CUST02010001") {
            Toast.info(res.msg, 3);
            if (res.data.tierType != 4) {
              _this.setState(
                {
                  type: false,
                },
                () => {
                  if (plateformType) {
                    this.backPapers();
                  }
                }
              );
            } else {
              _this.setState(
                {
                  type: true,
                },
                () => {
                  if (plateformType) {
                    this.backPapers();
                  }
                }
              );
            }
          } else {
            if (plateformType) {
              if (res.data.tierType != 4) {
                _this.setState(
                  {
                    type: false,
                  },
                  () => {
                    this.backPapers();
                  }
                );
              } else {
                _this.setState(
                  {
                    type: true,
                  },
                  () => {
                    this.backPapers();
                  }
                );
              }
            } else {
              if (!res.data.account) {
                if (res.data.tierType != 4) {
                  _this.setState({
                    type: false,
                  });
                } else {
                  _this.setState({
                    type: true,
                  });
                }
              } else {
                href("/ACFaceCa");
              }
            }
          }
        } else {
          if (res.code == "-1") {
            href("/ACLogin");
            Toast.info("登录失效", 1);
          } else {
            Toast.info("校验是否实名失败", 1);
          }
        }
      },
      (res) => {
        console.log("校验是否实名失败", res);
        if (res.code == "-1") {
          href("/ACLogin");
          Toast.info("登录失效", 1);
        } else {
          Toast.info("校验是否实名失败", 1);
        }
      }
    );
  };

  backPapers = () => {
    const { plateformType } = this.props;
    let url = "";

    if (this.state.type) {
      url = "/ACPersonalPapers";
      if (this.state.urlOps.mobileNumber) {
        if (plateformType) {
          url = `${url}?mobileNumber=${this.state.urlOps.mobileNumber}&plateformType=${plateformType}`;
        } else {
          url = `${url}?mobileNumber=${this.state.urlOps.mobileNumber}`;
        }
      } else {
        if (plateformType) {
          url = `${url}?plateformType=${plateformType}`;
        }
      }
      href(url);
    } else {
      url = "/ACEnterprosePapers";
      if (this.state.urlOps.mobileNumber) {
        if (plateformType) {
          url = `${url}?mobileNumber=${this.state.urlOps.mobileNumber}&plateformType=${plateformType}`;
        } else {
          url = `${url}?mobileNumber=${this.state.urlOps.mobileNumber}`;
        }
      } else {
        if (plateformType) {
          url = `${url}?plateformType=${plateformType}`;
        }
      }
      href(url);
    }
  };

  render() {
    let { type, iconType } = this.state;
    return (
      <div className="ACGuideBox">
        <div className="jingTai">
          <div>
            <div>
              <i>1</i>
              <span>实名认证</span>
            </div>
            <div className="jingTaiHG">
              <div></div>
            </div>
            <div>
              <i>2</i>
              <span>合同签署</span>
            </div>
          </div>
        </div>
        <img src={bgPNG} />
        {type ? (
          <div className="fuCeng">
            <img src={gerenPNG} />
            <p>
              您暂未进行实名认证，请前往完成实名认证，完成实名认证后即可进行合同签署
            </p>
            <div className="agreeBox">
              <label
                onClick={() => {
                  this.setState({
                    iconType: !iconType,
                  });
                }}
              >
                {iconType ? <Icon type="check" /> : <Icon />}
                去认证即代表同意
              </label>
              <a
                onClick={() => {
                  this.setState({
                    DCPType: true,
                  });
                }}
              >
                《数字证书使用协议》
              </a>
            </div>
            {iconType ? (
              <Button
                type="primary"
                onClick={() => {
                  this.backPapers();
                }}
              >
                去认证
              </Button>
            ) : (
              <Button type="primary" disabled>
                去认证
              </Button>
            )}
          </div>
        ) : (
          <div className="fuCeng">
            <img src={qiyePNG} />
            <p>
              您还暂未进行企业认证，请前往完成认证，完成认证后即可进行合同签署
            </p>
            <div className="agreeBox">
              <label
                onClick={() => {
                  this.setState({
                    iconType: !iconType,
                  });
                }}
              >
                {iconType ? <Icon type="check" /> : <Icon />}
                去认证即代表同意
              </label>
              <a
                onClick={() => {
                  this.setState({
                    DCPType: true,
                  });
                }}
              >
                《数字证书使用协议》
              </a>
            </div>
            {iconType ? (
              <Button
                type="primary"
                onClick={() => {
                  this.backPapers();
                }}
              >
                去认证
              </Button>
            ) : (
              <Button type="primary" disabled>
                去认证
              </Button>
            )}
          </div>
        )}
        {this.state.DCPType ? (
          <DigitalCertificateProtocolText
            onQuit={(DCPType) => {
              this.setState({
                DCPType,
              });
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default ACGuide;



// WEBPACK FOOTER //
// ./src/authCertificate/ACGuide/index.js